import { Star } from 'lucide-react';
import type { ReactNode } from 'react';
import type { CorStatus } from '../tokens/tokens';
import { BotaoIcone } from './Botao';
import { BolinhaStatus } from './Pilula';

export interface CabecalhoPaginaProps {
  titulo: string;
  codigo?: string;
  trilha?: { rotulo: string; href?: string }[];
  status?: { cor: CorStatus; rotulo: string };
  favorito?: boolean;
  aoFavoritar?: () => void;
  /** Linha de contexto abaixo do título (ex.: quantos registros). */
  descricao?: ReactNode;
  /** Ações secundárias à esquerda da primária. */
  acoes?: ReactNode;
  /** A única ação primária da página (07 §1.7). */
  primaria?: ReactNode;
}

export function CabecalhoPagina({ titulo, codigo, trilha, status, favorito, aoFavoritar, descricao, acoes, primaria }: CabecalhoPaginaProps) {
  return (
    <header className="cabecalho-pagina">
      <div className="cabecalho-pagina-titulo">
        {trilha && trilha.length > 0 && (
          <nav aria-label="Trilha" className="cabecalho-trilha">
            {trilha.map((t, i) => (
              <span key={t.rotulo + i}>{i > 0 && <span aria-hidden="true" className="cabecalho-trilha-sep">/</span>}{t.rotulo}</span>
            ))}
          </nav>
        )}
        <div className="cabecalho-linha">
          <h1 className="tp-titulo">{titulo}</h1>
          {codigo && <span className="mono texto-3 cabecalho-codigo">{codigo}</span>}
          {status && <BolinhaStatus cor={status.cor} rotulo={status.rotulo} />}
          {aoFavoritar && (
            <BotaoIcone
              rotulo={favorito ? 'Remover dos favoritos (Ctrl+D)' : 'Adicionar aos favoritos (Ctrl+D)'}
              aria-pressed={favorito}
              icone={<Star size={18} strokeWidth={1.75} fill={favorito ? 'currentColor' : 'none'} />}
              onClick={aoFavoritar}
              className={favorito ? 'favorito-ativo' : undefined}
            />
          )}
        </div>
        {descricao && <p className="cabecalho-descricao">{descricao}</p>}
      </div>
      <div className="cabecalho-acoes">
        {acoes}
        {primaria}
      </div>
    </header>
  );
}
